import React, {Fragment} from 'react'
import Counter from "../../../components/counter";
import {Trans} from "@lingui/react/macro";

export default function ScreenBarPartner({context, campagneData, colors = {}, mini}){

    // Campagne en montant (euros), pas en parrainage : on n'applique aucune division.
    const total = campagneData.stats.total.sum.total


    let bonus = null
    let _objectif = campagneData.objectif
    if(_objectif < total && Array.isArray(campagneData?.bonus) && campagneData?.bonus.length > 0){
        bonus = campagneData.bonus.find(b => b > total)
        if(!bonus){
            bonus = campagneData.bonus.at(-1)
        }
    }
    if(bonus){
        _objectif = bonus
    }

    let percent = (_objectif>0 ? (total / _objectif) * 100 : 0)
    const displayPercent = (Number(campagneData.objectif)>0 ? (total / campagneData.objectif) * 100 : 0)

    // Devise ignorée : on affiche toujours le mot "nis".
    // Séparateur des milliers en point pour matcher la maquette (900.000).
    const formater = new Intl.NumberFormat('de-DE', {maximumFractionDigits: 0})
    const objectifLabel = formater.format(campagneData.objectif)


    if(percent>100){
        percent=100
    }

    return (
        <Fragment>
            <div className={"d-flex justify-content-around align-items-center"} style={{flexDirection: "column", gap: 0}}>

                {/* Grand nombre */}
                <div style={{display: "flex", flexDirection: "column"}}>
                    <span style={{
                        textAlign: "center",
                        fontFamily: "Talpiot-Playfair",
                        fontStyle: "italic",
                        fontWeight: 600,
                        fontSize: "15vh",
                        lineHeight: 1,
                        color: colors.white || "#FFF",
                        textShadow: "rgba(0,0,0,.32) 0px 5px 21px",
                    }}>
                        <Counter number={total} decimals={0} preserveValue separator="."/> nis
                    </span>
                </div>

                {/* Barre de progression */}
                <div style={{
                    backgroundColor: "#D2B171A0",
                    padding: 8,
                    height: "5vh",
                    width: "60vw",
                    borderRadius: 50,
                    overflow: "hidden",
                    marginTop: "3vh",
                }}>
                    <div style={{
                        borderRadius: 50,
                        width: percent + "%",
                        height: "100%",
                        backgroundColor: colors.gold || "#D2B171",
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        paddingRight: "1.8vw",
                    }}>
                        {/*displayPercent >= 20 && (
                            <span style={{fontSize: "3vh", color: "#FFF", fontFamily: "Talpiot-Proxima", fontWeight: 500}}>
                                {Math.floor(displayPercent)}%
                            </span>
                        )*/}
                    </div>
                </div>

                {/* Sous-titre objectif */}
                <div style={{
                    marginTop: "3vh",
                    textAlign: "center",
                    color: colors.white || "#FFF",
                    fontSize: "6vh",
                    fontFamily: "Talpiot-Playfair",
                    fontStyle: "italic",
                    fontWeight: 600,
                    textShadow: "rgba(0,0,0,.25) 0px 3px 14px",
                }}>
                    <Trans>Objectif</Trans> {objectifLabel} nis
                </div>

            </div>
        </Fragment>
    )
}
